import { Divider, Form, Input, InputNumber, Select } from "antd";
import React from "react";
import { citiesData } from "../../../../../citiesData";
import { useSelector } from "react-redux";

function JobDetails({ form }) {
  const urlQualification = "v1/ap/qualification/getAllQualifications";
  const urlStudy = "v1/ap/study-area";
  const urlOccupation = "v1/ap/occupation/occupations";

  const { dataQualification, dataStudy, dataOccupation } = useSelector(
    (state) => ({
      dataQualification: state.dropdown.data[urlQualification] || [],
      dataStudy: state.dropdown.data[urlStudy] || [],
      dataOccupation: state.dropdown.data[urlOccupation] || [],
    })
  );

  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
 
  return (
    <>
      <div className="text-[#0B363D] font-[600] text-[1.5rem] font-dmSans mt-[2.5rem]">
        2. Job Details
      </div>
      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Basic Information
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="jobPosition"
          label={"Position Name"}
          rules={[
            {
              required: true,
              message: "Please add Position Name",
            },
          ]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item
          name="jobSklCatId"
          className=""
          label={"Occupation"}
          rules={[
            {
              required: true,
              message: "Please select occupation",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataOccupation?.length > 0 &&
              dataOccupation?.map((item) => ({
                value: item?.sklCatId,
                label: item?.sklCatName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>

        <Form.Item
          name="jobVacancyCount"
          label={"No. of vacancies"}
          rules={[
            {
              required: true,
              message: "Please add No. of vacancies",
            },
          ]}
        >
          <InputNumber
            min={0}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
            placeholder="Enter value"
            className="input flex"
          />
        </Form.Item>

        <Form.Item
          name="jobStdId"
          className=""
          label={"Area of Study"}
          rules={[
            {
              required: true,
              message: "Please select area of study",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataStudy?.length > 0 &&
              dataStudy?.map((item) => ({
                value: item?.stdId,
                label: item?.stdName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>

        <Form.Item
          name="jobQuaId"
          className=""
          label={"Qualification Required"}
          rules={[
            {
              required: true,
              message: "Please select qualification required",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataQualification?.length > 0 &&
              dataQualification?.map((item) => ({
                value: item?.quaId,
                label: item?.quaName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      </div>

      <div className="mt-[1.5rem] mb-[1.5rem] text-[#0B363D] text-[1.125rem] font-[500] font-dmSans">
        Location Information
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-10">
        <Form.Item
          name="jobCity"
          className=""
          label={"City"}
          rules={[
            {
              required: true,
              message: "Please select area of study",
            },
          ]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              citiesData?.length > 0 &&
              citiesData?.map((item) => ({
                value: item?.name,
                label: item?.name,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      </div>
    </>
  );
}

export default JobDetails;
